<template>
    <v-container>
        <h1>Classes</h1>
        <v-card v-for="(characterClass, characterClassIndex) in characterClasses" :key="characterClassIndex"
                class="my-4">
            <v-card-title>{{ characterClass.name }}</v-card-title>

            <v-card-text>
                <div>Perks</div>
                <div v-for="(perk, perkIndex) in characterClass.perks" :key="perkIndex">
                    {{ perk.amount }} - {{ perk.description }}
                </div>
            </v-card-text>

            <v-card-actions>
                <v-btn @click="$router.push({name: 'character-class', params: {characterClassId: characterClass.id}})">
                    View Class
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
  import CharacterClassService from "../services/CharacterClassService";

  export default {
    data: () => ({
      characterClasses: []
    }),

    created() {
      this.indexCharacterClasses();
    },

    methods: {
      indexCharacterClasses() {
        CharacterClassService.index()
          .then(response => {
            this.characterClasses = response.data.data;
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
  };
</script>